import { DateTime, Interval } from 'luxon';
import { toDateTime } from '@arc/shared/util-js';

/** DO NOT EXPORT THIS. USE ONE OF THE OTHER FUNCTIONS INSTEAD! */
function formatDateTime(dateTime, formatOptions, localeOptions, setTimezone = true) {
  dateTime = toDateTime(dateTime, setTimezone);

  // It seems that toDateTime returns undefined when it cannot parse dateTime.
  // Just return an empty string in these cases.
  if (!dateTime) return '';
  const dateTimeTz = setTimezone ? dateTime.toLocal() : dateTime;
  return dateTimeTz.toLocaleString(formatOptions, localeOptions)
  // replace a space before 'AM' or 'PM' with a non-breaking space
  .replace(/ (?=AM|PM)/u, '\u00A0').replaceAll(',', '');
}
function isToday(dateTime) {
  const today = Interval.fromDateTimes(DateTime.local().startOf('day'), DateTime.local().endOf('day'));
  return today.contains(toDateTime(dateTime));
}

/**
 * Format as date with two digit year without time of day.
 */
export function formatShortDate(dateTimeValue, setTimezone = true) {
  const dateTime = toDateTime(dateTimeValue, setTimezone);
  return dateTime?.toFormat('MM/dd/yy') ?? '';
}

/**
 * Format as date without time of day.
 */
export function formatDate(dateTime, setTimezone = true) {
  return formatDateTime(dateTime, DateTime.DATE_SHORT, undefined, setTimezone);
}

/**
 * Format as time of day without date.
 */
export function formatTime(dateTime, setTimezone = true) {
  return formatDateTime(dateTime, DateTime.TIME_SIMPLE, undefined, setTimezone);
}

/**
 * Format as time of day and date.
 */
export function formatDateAndTime(dateTime) {
  return formatDateTime(dateTime, DateTime.DATETIME_SHORT);
}

/**
 * Format as time of day if the dateTime is today. Otherwise, format as date.
 */
export function formatDateOrTime(dateTime) {
  if (isToday(dateTime)) {
    return formatTime(dateTime);
  } else {
    return formatDate(dateTime);
  }
}